import React from 'react';

const ResearchEnvironment = () => {
  return (
    <section className='bg-[#fafafa] px-5 pb-32 pt-20 md:px-8 lg:pb-36 lg:pt-24 xl:pb-40 xl:pt-28'>
      <div className='mx-auto w-full max-w-[1100px]'>
        <hr className='mb-12 border-0 h-[1px] bg-[#eeeeee]' />
        <div className='max-w-[680px]'>
          <h2 className='metro-semi mb-4 mt-2 text-[34px] text-primary-dark'>Research Environment</h2>
          <p className='metro mb-4 text-[15px] leading-[1.7] text-[#555555] md:text-[16px]'>
            QLab operates a systematic research program focused on identifying persistent statistical
            signals across digital asset markets.
          </p>
          <p className='metro mb-4 text-[15px] leading-[1.7] text-[#555555] md:text-[16px]'>
            Our infrastructure supports large-scale data analysis, systematic model validation, and
            disciplined execution under realistic market conditions.
          </p>
          <p className='metro text-[15px] leading-[1.7] text-[#555555] md:text-[16px]'>
            Research is conducted through an iterative process of hypothesis formation, statistical
            testing, out-of-sample validation, and controlled deployment.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ResearchEnvironment;
